__turbopack_context__.v({
  "bottom": "Cards-module__OuHqJW__bottom",
  "chip": "Cards-module__OuHqJW__chip",
  "content": "Cards-module__OuHqJW__content",
  "contentOverlay": "Cards-module__OuHqJW__contentOverlay",
  "dropShadow": "Cards-module__OuHqJW__dropShadow",
  "forMod": "Cards-module__OuHqJW__forMod",
  "frame-decor": "Cards-module__OuHqJW__frame-decor",
  "fullOverlay": "Cards-module__OuHqJW__fullOverlay",
  "glowing": "Cards-module__OuHqJW__glowing",
  "gradientOverlay": "Cards-module__OuHqJW__gradientOverlay",
  "header": "Cards-module__OuHqJW__header",
  "iconBadge": "Cards-module__OuHqJW__iconBadge",
  "image": "Cards-module__OuHqJW__image",
  "imageGroupContainer": "Cards-module__OuHqJW__imageGroupContainer",
  "imageGroupContainer4x4": "Cards-module__OuHqJW__imageGroupContainer4x4",
  "infoChip": "Cards-module__OuHqJW__infoChip",
  "link": "Cards-module__OuHqJW__link",
  "mantine-Badge-label": "Cards-module__OuHqJW__mantine-Badge-label",
  "mantine-Divider-root": "Cards-module__OuHqJW__mantine-Divider-root",
  "noHover": "Cards-module__OuHqJW__noHover",
  "noImage": "Cards-module__OuHqJW__noImage",
  "reactions": "Cards-module__OuHqJW__reactions",
  "root": "Cards-module__OuHqJW__root",
  "statChip": "Cards-module__OuHqJW__statChip",
  "top": "Cards-module__OuHqJW__top",
  "winnerFirst": "Cards-module__OuHqJW__winnerFirst",
  "winnerSecond": "Cards-module__OuHqJW__winnerSecond",
  "winnerThird": "Cards-module__OuHqJW__winnerThird",
});
